import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon'
import { faFireExtinguisher } from '@fortawesome/free-solid-svg-icons'

export const EquipmentIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faFireExtinguisher} color={props.color || 'black'} />
  )
}
